var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basicBox"},[_vm._v(" Copyright © 2018-2021 山西复盛公健康药业有限公司 版权所有 "),_c('span',{on:{"click":function($event){return _vm.jumpUrl()}}},[_vm._v(" 备案号：晋ICP备18000185号-4")])])}
var staticRenderFns = []

export { render, staticRenderFns }